var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{class:_vm.type==1?'item itemAc':'item',on:{"click":function($event){return _vm.typeChange(1)}}},[_vm._v(" "+_vm._s(_vm.i18n('29'))+" ")]),_c('div',{class:_vm.type==2?'item itemAc':'item',on:{"click":function($event){return _vm.typeChange(2)}}},[_vm._v(" "+_vm._s(_vm.i18n('118'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }